export const environment = {
  production: true,
  fallbackLocale: 'es-ES',
  tenant: 'activities_ESP',
  widget: false,
  serviceWorker: {
    enable: true,
  },
  e2e: {
    // enable e2e mode with data-test markup
    enable: false,
  },
  applications: {
    datadog: {
      applicationId: 'f2062e7c-738c-4e68-80c7-431aede71afb',
      clientToken: 'pub479f0afae0f5f45fa57ee25866064036',
    },
    cdn: {
      host: 'https://activities-assets.decathlon.net/legacy',
      root: 'https://activities-assets.decathlon.net',
    },
    phrase: {
      locales: {
        'es-ES': ''
      },
    },
    front: {
      url: 'https://activities.decathlon.es',
      domain: 'activities.decathlon.es',
    },
    woosmap: {
      apiKey: 'woos-6e588fc5-a1e3-3d39-9ee1-28b713fdd5df',
      gmapApiKey: 'AIzaSyDG3jq0cm9JoLe9E8PCAZaawAHrfQ7U_ss',
      locale: 'country:es',
    },
    amplitude: {
      apiKey: 'c06224e8147966f6ffae12a7f2d7d198',
    },
    gtm: {
      id: 'GTM-MTM3WV9',
    },
    sentry: {
      dsn: 'https://0fc1729944bc4fa1a21e1cab26bd34ad@sentry.io/1396593',
      environment: 'production-ESP',
      enabled: true
    },
    talkjs: {
      appId: 'QFqHH3hk'
    },
    activities: {
      url: 'https://api-eu.decathlon.net/activities/v2',
      api_key: '809d3f33-06cc-46cc-b4cf-b612b4a6b479',
    },
    strapi: {
      url: 'https://activities.decathlon.es/strapi-api',
      locale: 'en',
    },
    stripe: {
      apiKey: 'pk_live_51Ib18VCsyElNYErsMK1Yy1jlMWq8hPgyud8jKpWx594VkLsFPH5LGWqngq2fHCcnhy6UTZJI1zgE2ybkgMZfqj9r00KuOX5N80',
      authorizeUri: 'https://connect.stripe.com/express/oauth/authorize',
      apiUrl: 'https://connect.stripe.com',
    },
    pfs: {
      url: 'https://europe-west1-services-platform-pwlg.cloudfunctions.net/api'
    },
    advice: {
      url: 'https://api-global.decathlon.net/cms',
      apiKey: 'c1bd69cf-9822-49be-819a-a42dd47cb043',
    },
    reviews: {
      url: 'https://reviews.decathlon.com',
    },
    onepay: {
      host: 'https://onepay-widget.decathlon.net',
    },
  },
  auth: {
    fed: {
      issuer: 'https://idpdecathlon.oxylane.com',
      redirectUri: 'https://activities.decathlon.es/auth/redirection',
      clientId: 'Cc73544e2464f2bbb5585c8508f0d4ceba0afa720',
      userinfoEndpoint:
        'https://idpdecathlon.oxylane.com/idp/userinfo.openid',
      discoveryDocument:
        'https://idpdecathlon.oxylane.com/.well-known/openid-configuration',
    },
    connect: {
      issuer: 'https://api-eu.decathlon.net/connect',
      redirectUri: 'https://activities.decathlon.es/auth/redirection',
      clientId: 'bd90d851-4ac7-494c-9b53-9a1846a039e7',
      discoveryDocument:
        'https://api-global.decathlon.net/connect/.well-known/openid-configuration',
      logoutRedirectionUrl: 'https://activities.decathlon.es/auth/logout',
    },
  }
};

